<template>
    <div v-if="item.hasPermission && item.hasOnboarding">
        <div
          data-vs-button="change-section-button"
          @click='changeSection (item)'
          :class="item.show ? 'section-active' : ''"
          class="sections-style"
          :key="item.id">
            <div
              class="icon-style"
              :class="item.icon">
            </div>
            <div class="section-title">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "UserOption",
        props: ['item', 'myself'],
        methods:{
            changeSection (item){
                this.$emit("changeSection", item)
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "./public/assets/scss/_config.scss";

    .icon-style{
        margin: 0vw 0px .3vw 1vw;
        top: 0 !important;
        font-size: 1.4vw !important;
    }

    .sections-style {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 5vw;
        border-left: 4px solid $white;
        border-radius: 10px;
        &:hover{
            cursor: pointer;
            border-radius: 0;
            border-left: 4px solid $button-primary-hover;
            .section-title {
                color: $bluePrimary;
            }
            .icon-Statics:before,
            .icon-Licencias:before,
            .icon-Person:before,
            .icon-ResetPass:before,
            .icon-Refresh:before,
            .icon-Doc:before,
            .icon-Config:before {
                color: $bluePrimary !important;
            }
        }

    }

    .section-active{
        border-left: 4px solid $button-primary-hover;
        border-radius: 0;
        cursor: pointer;
        .section-title {
            color: $bluePrimary;
        }
        .icon-Statics:before,
        .icon-Licencias:before,
        .icon-Person:before,
        .icon-ResetPass:before,
        .icon-Refresh:before,
        .icon-Doc:before,
        .icon-Config:before {
            color: $bluePrimary !important;
        }
    }

    .section-title {
        font-size: 16px;
        display: flex;
        width: 100%;
        font-weight: normal;
        color: $text-secondary;
        margin-left: 15%;
        margin-right: 5%;
    }

    .sections-fobidden:hover {
        cursor: not-allowed;
        border-left: 4px solid $white;

        .section-title,
        .icon-Config:before {
            color: $gray !important;
        }
    }

    .sections-fobidden{
        .section-title, .icon-Config:before{
            color: $gray !important;
        }
    }


</style>